module.exports = __webpack_public_path__ + "static/media/hero-4.1d2870d3.jpg";